import ConsoleReducer from "./reducer";

export const openMobileMenuModal = () => (dispatch) => {
  dispatch(ConsoleReducer.actions.openMobileMenuModal());
};

export const setNewsUser = (payload) => (dispatch) => {
  dispatch(ConsoleReducer.actions.setNewsUser(payload));
};

export const closeMobileMenuModal = () => (dispatch) => {
  dispatch(ConsoleReducer.actions.closeMobileMenuModal());
};

export const openHomeAdModal = () => (dispatch) => {
  dispatch(ConsoleReducer.actions.openHomeAdModal());
};

export const closeHomeAdModal = () => (dispatch) => {
  dispatch(ConsoleReducer.actions.closeHomeAdModal());
};
